import { createContext } from 'react'

export const GestionContext = createContext()
